<template>
  <div class="supported-story-types">
    <div class="container">
      <div
        v-for="v in value"
        :key="v.id"
        class="story-type"
        :class="{'cursor-pointer': admin, 'supported': v.supported}"
        @click="storyTypeClicked(v.id)"
      >
        {{idToName[v.id]}}
      </div>
    </div>
    <div class="cf-form-hint">
      {{this.hintText}}

    </div>
  </div>
</template>

<script>
const storyTypeIDFiledNames = ['storyType1ID', 'storyType2ID', 'storyType3ID', 'storyType4ID'];
const storyTypeNameFiledNames = ['storyType1Name', 'storyType2Name', 'storyType3Name', 'storyType4Name'];

export default {
  name: 'SupportedStoryTypes',
  data() {
    return {
      // Widget will be read only if the user is not admin
      admin: false,

      // Holds persisted data of this field
      value: [
        // Example. { id: "projectStory", supported: true },
      ],

      // Maps storyID to storyName
      idToName: {
        // Example. "projectStory": "Project Story",
      },
    };
  },
  computed: {
    hintText() {
      const textAboutReadOnly = this.admin === false ? ' This field is read-only.' : '';
      return `Indicates what story types are supported for this screen. Blue: supported, Gray: not supported.${textAboutReadOnly}`;
    },
  },
  mounted() {
    // Store if the current user is admin
    const user = this.$extension.user;
    this.admin = user.spaceMembership.admin;

    // Load story type ids and names from installation parameters
    this.loadStoryIDAndName();

    // Load stored value from Contentful, and merge with installation parameters
    this.getValueFromContentfulAndMerge();

    console.log('merged value', this.value);
  },
  methods: {
    loadStoryIDAndName() {
      for (let i = 0; i < storyTypeIDFiledNames.length; i++) {
        const storyID = this.$extension.parameters.installation[storyTypeIDFiledNames[i]];
        const storyName = this.$extension.parameters.installation[storyTypeNameFiledNames[i]];

        if (storyID && storyName && storyID.length > 0 && storyName.length > 0) {
          this.idToName[storyID] = storyName;
          this.value.push({id: storyID, supported: false});
        }
      }
    },
    getValueFromContentfulAndMerge() {
      const cfValue = this.$extension.field.getValue();

      if (cfValue && cfValue.value) {
        for (let storyType of cfValue.value) {
          if (this.idToName[storyType.id]) {
            // Take value from data on Contentful, if it's a still valid type
            this.setSupportedStatus(storyType);
          }
        }
      }
    },
    setSupportedStatus(storyType) {
      for (let v of this.value) {
        if (v.id === storyType.id) {
          v.supported = storyType.supported;
          return;
        }
      }
    },
    flipSupportedStatus(storyId) {
      for (let v of this.value) {
        if (v.id === storyId) {
          v.supported = !v.supported;
          return;
        }
      }
    },
    setValueToContentul() {
      this.$extension.field.setValue({value: this.value})
        .catch((err) => {
          console.error(err)
        });
    },
    storyTypeClicked(id) {
      // Only admin role can modify data
      if (this.admin) {
        this.flipSupportedStatus(id);
        this.setValueToContentul();
      }
    },
  }
};
</script>

<style scoped lang="scss">
  .story-type {
    display: inline-block;
    margin-right: 16px;
    font-size: 12px;
    padding: 6px 16px;
    border-radius: 6px;
    user-select: none;
    color: rgb(128, 145, 165);
    background-color: rgb(247, 249, 250);
    border: 1px solid rgb(128, 145, 165);
    text-decoration: line-through;
  }

  .container {
    margin-top: 18px;

    // Taken from Contentful CSS
    border-width: 0 0 1px 0;
    border-style: solid;
    border-color: transparent;
    border-image-width: 0 0 1px 0;
    border-image-source: url(https://static.contentful.com/app/svg/dotted-border.svg);
    border-image-repeat: round;
    border-image-slice: 1 1;

    padding-bottom: 12px;
  }

  .supported {
    color: white;
    background-color: rgb(74, 144, 226);
    border-color: rgb(74, 144, 226);
    text-decoration: none;
  }

  .cursor-pointer {
    cursor: pointer;
  }
</style>
